import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const HistoryList = Loadable(
  lazy(() => import("features/bookTransfer/components/HistoryList")),
);
const TransferPage = Loadable(
  lazy(() => import("features/bookTransfer/components/TransferPage")),
);

const routes = {
  path: "booktransfer",
  children: [
    { path: "", element: <HistoryList /> },
    { path: "add", element: <TransferPage /> },
    { path: "history", element: <HistoryList /> },
  ],
};

export default routes;
